import { render } from "./TBLDashboardIndividual.vue?vue&type=template&id=8082ff04&scoped=true"
import script from "./TBLDashboardIndividual.vue?vue&type=script&lang=js"
export * from "./TBLDashboardIndividual.vue?vue&type=script&lang=js"

import "./TBLDashboardIndividual.vue?vue&type=style&index=0&id=8082ff04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8082ff04"]])

export default __exports__